import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isMember',
  standalone: true
})
export class IsMemberPipe implements PipeTransform {

  transform(members: [], memberId: any): any {
    return members.some((m: any) => m?.user_id == memberId);
  }

}
